<script>
export default {
  name: 'GynaeHistoryTab',
  data() {
    return {
      form: {
        lmp: null,
        gravida: null,
        para: null,
        arbotus: null,
        living_children: null,
        is_pregnant: "unknown",
        menopausal_status: "unknown",
        edd: null,
        contraceptive_method: "",
        notes: ""
      }
    }
  },
  methods: {
    submitGynaeHistory() {
      this.$emit("gynae-history-submitted", { gynae_history: { ...this.form } })
    }
  }
}
</script>

<template>
  <div class="p-6 space-y-6">
    <h3 class="text-base font-semibold text-gray-700 border-b pb-2">
      Gynaecological & Obstetric History
    </h3>

    <div class="grid grid-cols-2 gap-x-6 gap-y-5">
      <!-- LMP -->
      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Last Menstrual Period (LMP)</label>
        <input
          v-model="form.lmp"
          type="date"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>

      <!-- Currently Pregnant -->
      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Currently Pregnant</label>
        <select v-model="form.is_pregnant" class="w-full border border-gray-300 rounded px-3 py-2 text-sm">
          <option value="unknown">Unknown</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>

      <!-- EDD — only when pregnant = yes -->
      <div v-if="form.is_pregnant === 'yes'" class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Expected Date of Delivery (EDD)</label>
        <input
          v-model="form.edd"
          type="date"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>

      <!-- GPAL -->
      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Gravida (G)</label>
        <input
          v-model.number="form.gravida"
          type="number"
          min="0"
          placeholder="Total pregnancies"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>

      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Para (P)</label>
        <input
          v-model.number="form.para"
          type="number"
          min="0"
          placeholder="Births ≥ 20 weeks"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>

      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Abortus (A)</label>
        <input
          v-model.number="form.abortus"
          type="number"
          min="0"
          placeholder="Miscarriages / terminations"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>

      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Living Children (L)</label>
        <input
          v-model.number="form.living_children"
          type="number"
          min="0"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>

      <!-- Menopausal status -->
      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Menopausal Status</label>
        <select v-model="form.menopausal_status" class="w-full border border-gray-300 rounded px-3 py-2 text-sm">
          <option value="unknown">Unknown</option>
          <option value="pre_menopausal">Pre-menopausal</option>
          <option value="peri_menopausal">Peri-menopausal</option>
          <option value="post_menopausal">Post-menopausal</option>
        </select>
      </div>

      <!-- Contraceptive method -->
      <div class="space-y-1">
        <label class="block text-sm font-medium text-gray-700">Contraceptive Method</label>
        <select v-model="form.contraceptive_method" class="w-full border border-gray-300 rounded px-3 py-2 text-sm">
          <option value="">None / Not using</option>
          <option value="oral_pills">Oral Contraceptive Pills</option>
          <option value="injectable">Injectable (Depo-Provera)</option>
          <option value="iud">IUD / IUCD</option>
          <option value="implant">Implant</option>
          <option value="condom">Condom</option>
          <option value="emergency">Emergency Contraception</option>
          <option value="natural">Natural / Rhythm Method</option>
          <option value="other">Other</option>
        </select>
      </div>

      <!-- Notes — full width -->
      <div class="col-span-2 space-y-1">
        <label class="block text-sm font-medium text-gray-700">Additional Notes</label>
        <textarea
          v-model="form.notes"
          rows="3"
          placeholder="Any other relevant gynaecological or obstetric information..."
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>
    </div>
  </div>
</template>